import React from "react";

const TechBadge = ({
  techName,
  color = "bg-blue-500",
  textColor = "text-white",
}) => {
  return (
    <span
      className={`inline-block px-3 py-1 rounded-full font-semibold text-sm ${color} ${textColor}`}
    >
      {techName}
    </span>
  );
};

export default TechBadge;
